import { Form, message } from 'antd';
import { useDispatch } from 'dva';
import { useState, useCallback, useEffect } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import Loading from '@/components/Loading';
import styles from './AddRule.less?modules';
// import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
// import SelectML from '@/components/select_ml/SelectML';
// import Cascader from '@/containers/cascader_ml/cascader_package_ml/CascaderPackage';
import SelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import SingInputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import Cascader from '@/containers/cascader_ml/cascader_package_add_ml/Cascader';
import { toOption } from '@/utils/comUtil.js';
import { outputTypeMap } from '@/constants.js';

const AddRule = (props) => {
  const { fetchData, handleCancel, parents, id, cascaderData, addOptions } =
    props || {};
  const { valueType, value } = parents || {};
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [outType, setOutType] = useState('CONSTANT');

  const setFrom = useCallback(() => {
    if (valueType === 'CONSTANT') {
      form.setFieldsValue({ ...parents });
    } else {
      form.setFieldsValue({ ...parents, value: cascaderData[value] });
    }
  }, [cascaderData, form, parents, value, valueType]);
  useEffect(() => {
    setFrom();
  }, [setFrom]);

  useEffect(() => {
    setOutType(valueType);
  }, [valueType]);

  // 发起请求
  const onFinish = (values) => {
    if (values.valueType === 'VARIABLE') {
      values['value'] = values['value'][1];
    }
    setLoading(true);
    if (!parents || JSON.stringify(parents) === '{}') {
      //新增逻辑
      dispatch({
        type: 'condition/addOutputList',
        payload: {
          values: {
            ruleOutputId: id,
            ...values,
          },
        },
        callback: (d) => {
          setLoading(false);
          console.log(d);
          if (d?.code) {
            message.error(d.message);
            return;
          }
          message.success('新增成功');
          fetchData();
          handleCancel();
        },
      });
    } else {
      //编辑逻辑
      dispatch({
        type: 'condition/editOutputList',
        payload: {
          values: {
            ruleOutputId: parents && parents.id,
            ...values,
          },
        },
        callback: () => {
          setLoading(false);
          message.success('编辑成功');
          fetchData();
          handleCancel();
        },
      });
    }
  };

  const handleCancels = () => {
    handleCancel();
  };
  const onSelectType = (e) => {
    setOutType(e);
    form.setFieldsValue({ ...parents, valueType: e, value: undefined });
  };
  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          <SingInputML
            height="37px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="输出项名称"
            placeVal="请输入输出项名称"
            name="itemName"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入输出项名称',
              },
            ]}
            className={['label-left']}
          />

          <SelectML
            height="47px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="输出项类型"
            placeVal="请选择"
            name="valueType"
            // allowClear={true}
            option={toOption(outputTypeMap)}
            onSelect={onSelectType}
            required={[
              {
                required: true,
                message: '请选择输出项类型',
              },
            ]}
          />
          {outType === 'CONSTANT' ? (
            <SingInputML
              height="47px"
              labelwidth="130px"
              inputWidth="269px"
              labelVal="输出项"
              placeVal="请输入输出项"
              name="value"
              className={['label-left']}
              required={[
                {
                  required: true,
                  message: '请输入输出项',
                },
              ]}
            />
          ) : (
            <Cascader
              height="47px"
              options={addOptions}
              allowClear={true}
              placeVal={'请选择'}
              labelwidth="130px"
              name={'value'}
              value={(() => {
                for (const key in cascaderData) {
                  if (key === value) {
                    return cascaderData[value];
                  }
                }
              })()}
              labelVal="输出项"
              form={form}
              className={['label-left', 'mt10']}
              required={[
                {
                  required: true,
                  message: '请选择输出项',
                },
              ]}
            />
          )}
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            htmlType="submit"
            fontsize="16px"
            onClick={handleCancels}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default AddRule;
